import { useState } from 'react';
import PropTypes from 'prop-types';
import { LoadingButton } from '@mui/lab';
import { enqueueSnackbar } from 'notistack';
import Iconify from '../iconify/Iconify';
import axiosInstance from '../../utils/axios';
import { objectToFormData } from '../../utils/objectToFormData';
import { fileDownload } from '../../utils/fileDownload';

ExcelDownloadTemplateButton.propTypes = {
  fields: PropTypes.array,
  fileName: PropTypes.string,
  worksheetName: PropTypes.string
}

export default function ExcelDownloadTemplateButton({ fields, fileName, worksheetName }) {
  const [loading, setLoading] = useState(false);

  const downloadFile = () => {
    axiosInstance.post(`/home/downloadExcel`, objectToFormData({ headers: fields, worksheetName }), { responseType: "blob" })
      .then(res => fileDownload(res.data, fileName))
      .catch(() => enqueueSnackbar('Download excel file failed', { variant: 'error' }))
      .finally(() => setLoading(false));
  }

  return <LoadingButton
    loading={loading}
    variant="outlined"
    color="secondary"
    size="small"
    onClick={downloadFile}
    startIcon={<Iconify icon="file-icons:microsoft-excel" />}
    sx={{ ml: 2 }}
  >
    Download Template
  </LoadingButton>;
}
